module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a5-12-b523da85f240a2bcfced440db81f60ff.jpg";